import styled from "styled-components";
import { SectionTitle, SectionSubtitle } from "components/Style";

const ProcessSection = styled.section`
  background-color: #f7f7f7;
  padding: 68px 0;
`;

const ProcessContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  text-align: center;
`;

const ProcessSteps = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 65px;
`;

const ProcessStepWrapper = styled.div`
  position: relative;
  margin: 55px 20px;
  margin-bottom: 20px;
  width: 210px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

const BlueBlock = styled.div`
  position: absolute;
  left: 50%;
  top: 0;
  width: 146px;
  height: 110px;
  background: linear-gradient(135deg, #1a4ffe 0%, #5c9dff 100%);
  border-radius: 16px 16px 73px 73px / 16px 16px 55px 55px;
  transform: translate(-50%, -50%);
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ProcessStep = styled.div`
  position: relative;
  text-align: center;
  width: 210px;
  height: 113px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  font-size: 18px;
  z-index: 1;
  backdrop-filter: blur(18px) brightness(1.08);
  background: rgba(255, 255, 255, 0.65);
  padding-top: 16px;

  .step-img {
    width: 44px;
    height: 44px;
    margin-bottom: 8px;
    border-radius: 8px;
    display: block;
  }

  p {
    font-size: 18px;
    margin: 0;
  }
`;

const StepNumber = styled.div`
  color: #fff;
  font-size: 34px;
  line-height: 60px;
  font-weight: 700;
  pointer-events: none;
`;

const FreeRegisterButton = styled.a`
  width: 356px;
  height: 56px;
  line-height: 56px;
  background: linear-gradient(161deg, #fdb016 0%, #f98415 100%);
  color: #fff;
  border-radius: 12px;
  text-decoration: none;
  display: block;
  margin: 25px auto 0 auto;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  box-shadow: 0 2px 8px rgba(253, 176, 22, 0.08);
  transition: filter 0.2s;
  cursor: pointer;
  &:hover {
    filter: brightness(0.96);
  }
`;

const PROCESS_STEPS = [
  { label: "选择产品" },
  { label: "选择金融服务机构" },
  { label: "提交材料" },
  { label: "完成支付" },
  { label: "下载保函" },
];
export function Guide() {
  return (
    <ProcessSteps>
      {PROCESS_STEPS.map((step, idx) => (
        <ProcessStepWrapper key={step.label}>
          <BlueBlock>
            <StepNumber>{String(idx + 1).padStart(2, "0")}</StepNumber>
          </BlueBlock>
          <ProcessStep>
            <img
              src={"/assets/home/step-" + (idx + 1) + ".png"}
              className="step-img"
            />
            <p>{step.label}</p>
          </ProcessStep>
        </ProcessStepWrapper>
      ))}
    </ProcessSteps>
  );
}

export default function Process() {
  return (
    <ProcessSection>
      <ProcessContainer>
        <SectionTitle>简单五步即可出函</SectionTitle>
        <SectionSubtitle>Five Simple Steps to Send a Letter</SectionSubtitle>
        <Guide />
        <FreeRegisterButton href="#">免费注册，立即申请保函</FreeRegisterButton>
      </ProcessContainer>
    </ProcessSection>
  );
}
